<template>
  <PanelPage ref="useAlerts" :loading-overlay="loadingOverlay" md="12">
    <v-card-title>Modify Client</v-card-title>
    <v-card-title>
      <v-autocomplete
        label="Client to modify"
        :items="clients"
        v-model="clientToModifyId"
        item-title="visual_name"
        item-value="id"
      />
    </v-card-title>
    <v-divider/>
    <v-form v-show="clientToModifyId" @submit.prevent="submit" @reset="handleReset">
      <v-card-text class="pb-0">
        <v-text-field
          v-model="form.name.value.value"
          :error-messages="form.name.errorMessage.value"
          label="Name used to identify the Client"
        />
        <v-text-field
          v-model="form.email.value.value"
          :error-messages="form.email.errorMessage.value"
          label="Email"
        />
        <v-text-field
          v-model="form.pennylane_id.value.value"
          :error-messages="form.pennylane_id.errorMessage.value"
          label="Pennylane Client ID"
        />
        <v-autocomplete
          label="Managed Parks"
          :items="parks"
          multiple
          chips
          v-model="form.parks.value.value"
          :error-messages="form.parks.errorMessage.value"
          item-title="name"
          item-value="id"
        />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn type="reset">Reset</v-btn>
        <v-btn type="submit" variant="elevated" color="green">Submit</v-btn>
      </v-card-actions>
    </v-form>
  </PanelPage>
</template>

<script setup>
import PanelPage from "@/components/PanelPage.vue";
import { onMounted, ref, watch } from "vue";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
import { getFormFromSchema } from "../utils.js";
import { createClient, fetchClients, modifyPutClients } from "@/remote/client";
import { fetchParks } from "@/remote/park";

// State
const useAlerts = ref(null);
const loadingOverlay = ref(false);
const parks = ref();
const clients = ref();
const clientToModifyId = ref(null);

watch(clientToModifyId, async (newValue) => {
  if (newValue !== null) {
    loadingOverlay.value = true;
    setClient(newValue);
    loadingOverlay.value = false;
  }
});

// Validation Schema
const schema = yup.object({
  name: yup.string().required(),
  email: yup.string().email(),
  pennylane_id: yup.string(),
  parks: yup.array().required(),
});

const { handleSubmit, handleReset } = useForm({
  validationSchema: schema,
});

const form = getFormFromSchema(schema);

const submit = handleSubmit(async (values) => {
  console.log(values);
  loadingOverlay.value = true;
  // Create Client
  try {
    await modifyPutClients(useAlerts, values, clientToModifyId.value);
  } catch (e) {
    console.log(e);
  } finally {
    clients.value = await fetchClients();
    loadingOverlay.value = false;
  }
});

function setClient(client_id) {
  const cl = clients.value.find(el => el['id'] === client_id);
  if (cl === undefined) {
    useAlerts.value.errorAlert("No Client with that ID in the system", "Contact an administrator");
    return;
  }
  // Fields = Values
  form.name.value.value = cl['name'];
  form.email.value.value = cl['email'];
  form.pennylane_id.value.value = cl['pennylane_id'];
  form.parks.value.value = cl['parks'];
}

onMounted(async () => {
  loadingOverlay.value = true;
  try {
    [parks.value, clients.value] = await Promise.all([fetchParks(), fetchClients()]);
  } catch (e) {
    useAlerts.value.errorAlert('Impossible to load parks info', e.toString());
  } finally {
    loadingOverlay.value = false;
  }
});

</script>

<style scoped>

</style>
